export var pickupDateError = 'Please select a date';
export var methodError = 'Select a pickup method';
export var planError = 'Select a payment plan';
export var partnerError = 'Please select a Partner';
export var labelUrlError = 'Please upload your label';
export var orderError = 'Please select an item to return';
export var orderLookupError = 'Please find your order';
export var briefDescriptionError = 'Enter brief description';
export var nameError = 'Enter your full name';
export var emailError = 'Enter a valid email address';
export var phoneError = 'Enter a valid phone number';
export var streetError = 'Enter your street address';
export var cityError = 'Enter your city';
export var zipCodeError = 'Enter valid zip';
export var emptyZipCodeError = 'Please enter zip';
export var zipCodeServiceError = "We're not in your neighborhood yet";
export var zipCodeRMSError = "*The Zip you have entered does not fall within the supported pickup range";
export var passwordError = 'Enter password';
export var passwordLengthError = 'Password must be at least 8 characters';
export var termsAndConditionsError = 'Please agree with terms and conditions';
export var verificationCode = 'Enter a valid verification code address';
export var passwordMismatch = 'Password mismatch';
export var packagesError = 'Add at least 1 package';
export var statusError = 'Select a package status';
export var descriptionError = 'Select a package description';
export var labelTypeError = 'Select a package labelType';
export var userSelectError = 'Please select a user';
export var addressSelectError = 'Please select an address';
export var dateError = 'Enter a valid date';
export var minDateError = 'Date should not be before minimal date';
export var maxDateError = 'Date should not be after maximal date';
export var companyError = 'Enter your Company name';
export var duplicateTrackingId = 'Tracking ID already exists';
export var trackindIdRequired = 'Please enter Tracking ID';
export var partnerNameError = 'Enter partner name';
export var partnerCodeError = 'Enter partner code';
export var headerColorError = 'Enter valid header color';
export var schedulerLimitError = 'Enter valid scheduler limit';
export var aboutYourselfError = 'Enter some information about yourself';
export var timeSlotError = 'Please choose your desired pickup time';
export var reternReasonError = 'Please select a return reason for this item';
export var quantityOrderError = 'Please select a quantity to return';
export var orderIDError = 'Please Enter an Order ID';
export var attributeHeader = 'Please add Attribute Header';
export var hubError = 'Please select a Hub';
export var driverError = 'Please select a Driver';
export var orderNumberError = 'Please enter an order number';
export var destinationError = 'Please select a Destination';
export var consolidationPackageError = 'This package is already tied to a consolidation - would you like to change the consolidation id for this package?';
export var cannotDeletePartnerDestination = 'This destination cannot be deleted because it is in use';
export var packageIsTiedToConsolidation = 'Package is already tied to a consolidation';
export var orderNotFound = 'This order number cannot be found. Please check your order number and try again.';
export var shopifyPartnerCodeMissed = 'Shop code not provided';
export var googleAccountsResetPasswordError = 'Error: Password reset unavailable - account uses Google Authentication.';
export var tripCxlReasonError = 'Please select a Trip Cancellation Reason';
export var tripDateUpdateError = function (status) {
    return "Date values cannot be changed on a ".concat(status, " trip \u2013 please wait until task creation is complete and try again.");
};
export var invalidUrlError = 'Please enter valid url';
export var labelIsMissingError = 'Label is missing';
export var printPackageTrackingIdError = function (packageIds) {
    return "ERROR: Package ".concat(packageIds.join(', '), " tracking ID is null");
};
export var scanRegisteredTaskUnassigned = 'Scan Registered - Task Unassigned';
export var returnDestinationMismatchError = function (packageId) {
    return "Package ".concat(packageId, " return destination does not match Consolidation Return Destination");
};
export var locationNameError = 'Please enter a location name';
export var locationTypeError = 'Please select a location type';
export var packageDelayReasonRequiredError = 'Please select a Package Delay Reason';
export var packageProblemReasonRequiredError = 'Package Problem Reason is required';
export var claimReasonsError = 'Please choose Claim Reason';
export var wrondPolybagId = 'Not valid QR Code';
//# sourceMappingURL=errors.js.map